import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageKeys } from '@core/constants/constants';

export const AlreadyLoginGuard: CanActivateFn = () => {
	const router = inject(Router);

	const accessToken = localStorage.getItem(StorageKeys.ACCESS_TOKEN);
	if (accessToken) {
		router.navigate(['']);
		return false;
	}
	return true;
};
